import {isNil} from 'ramda';

import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';
import {SettingsTemplateHeader} from '@dms/settings/shared';

import {Nullish} from 'shared/web';

export function buildWarehouseDirectSaleVariantsDetailHeader(
  directSaleVariantId: string | Nullish,
  directSaleVariantName: string | Nullish,
  isEditDisabled: boolean
): SettingsTemplateHeader {
  return {
    title: isNil(directSaleVariantId)
      ? i18n.t('entity.warehouse.labels.newDirectSaleVariant')
      : (directSaleVariantName ?? ''),
    breadcrumbs: [
      {
        label: i18n.t('entity.warehouse.labels.directSaleVariants'),
        href: settingsRoutes.warehousesDirectSaleVariants,
      },
    ],
    alerts: isEditDisabled
      ? [
          {
            type: 'banner',
            variant: 'info',
            message: i18n.t('entity.warehouse.labels.missingWarehouseDictionaryEditPermission'),
          },
        ]
      : undefined,
  };
}
